import { createElementVNode as _createElementVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center justify-content-end gap-3" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-filter" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  role: "group",
  "aria-label": "blah",
  class: "btn-group"
}, [
  /*#__PURE__*/_createElementVNode("input", {
    type: "radio",
    name: "Monthly",
    id: "btnradioM",
    autocomplete: "off",
    value: "M",
    class: "btn-check"
  }),
  /*#__PURE__*/_createElementVNode("label", {
    for: "btnradioM",
    class: "btn btn-sm btn-pill btn-outline-primary"
  }, "Monthly"),
  /*#__PURE__*/_createElementVNode("input", {
    type: "radio",
    name: "Yearly",
    id: "btnradioY",
    autocomplete: "off",
    value: "Y",
    class: "btn-check"
  }),
  /*#__PURE__*/_createElementVNode("label", {
    for: "btnradioY",
    class: "btn btn-sm btn-pill btn-outline-primary"
  }, "Yearly")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-plus" }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "container-fluid" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "alert alert-primary alert-fat alert-with-icon alert-dismissible fade show my-3 shadow",
    role: "alert"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "alert-icon fal fa-info-circle fa-lg" }),
    /*#__PURE__*/_createElementVNode("button", {
      type: "button",
      class: "btn-close",
      "data-bs-dismiss": "alert",
      "aria-label": "Close"
    }),
    /*#__PURE__*/_createElementVNode("div", { class: "" }, [
      /*#__PURE__*/_createElementVNode("div", null, [
        /*#__PURE__*/_createElementVNode("h4", { class: "alert-heading flex-grow-1" }, "Loupes"),
        /*#__PURE__*/_createElementVNode("p", null, " Loupes are a way to explore what happened before and after customers reached a specific point in your engagement. That reference point could be receiving a particular message, or taking an action. Loupes help you understand the journeys taken by your customers, and the future value the engagement has influenced. ")
      ])
    ])
  ])
], -1)
const _hoisted_7 = { class: "container-fluid my-3" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("ul", {
  id: "overview-tabs",
  class: "nav nav-tabs nav-tabs-primary",
  role: "tablist"
}, [
  /*#__PURE__*/_createElementVNode("li", {
    class: "nav-item",
    role: "presentation"
  }, [
    /*#__PURE__*/_createElementVNode("button", {
      id: "overview-timing-tab",
      class: "nav-link active",
      "data-bs-toggle": "tab",
      "data-bs-target": "#overview-timing-content",
      role: "tab",
      "aria-controls": "overview-timing-content",
      "aria-selected": "true"
    }, "Timing")
  ]),
  /*#__PURE__*/_createElementVNode("li", {
    class: "nav-item",
    role: "presentation"
  }, [
    /*#__PURE__*/_createElementVNode("button", {
      id: "overview-audience-tab",
      class: "nav-link",
      "data-bs-toggle": "tab",
      "data-bs-target": "#overview-audience-content",
      role: "tab",
      "aria-controls": "overview-audience-content",
      "aria-selected": "false"
    }, "Audience")
  ]),
  /*#__PURE__*/_createElementVNode("li", {
    class: "nav-item",
    role: "presentation"
  }, [
    /*#__PURE__*/_createElementVNode("button", {
      id: "overview-engagement-tab",
      class: "nav-link",
      "data-bs-toggle": "tab",
      "data-bs-target": "#overview-engagement-content",
      role: "tab",
      "aria-controls": "overview-engagement-content",
      "aria-selected": "false"
    }, "Engagement")
  ])
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "tab-content" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "tab-pane fade show active",
    id: "overview-timing-content",
    role: "tabpanel",
    "aria-labelledby": "overview-timing-tab"
  }),
  /*#__PURE__*/_createElementVNode("div", {
    id: "overview-audience-content",
    role: "tabpanel",
    "aria-labelledby": "overview-timing-tab"
  }),
  /*#__PURE__*/_createElementVNode("div", {
    id: "overview-engagement-content",
    role: "tabpanel",
    "aria-labelledby": "overview-timing-tab"
  })
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-plus" }, null, -1)
const _hoisted_11 = [
  _hoisted_10
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(), _createBlock(_Teleport, { to: "#filter-bar-content" }, [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-sm btn-primary",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleFilter && _ctx.toggleFilter(...args)))
        }, "Filter"),
        _hoisted_3,
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-sm btn-primary btn-round",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.testCall && _ctx.testCall(...args)))
        }, _hoisted_5)
      ])
    ])),
    _hoisted_6,
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _hoisted_9,
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-lg btn-primary btn-round",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleFilter && _ctx.toggleFilter(...args)))
        }, _hoisted_11)
      ])
    ])
  ]))
}